export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14240.f9c2a1f6.jpg";